export const secondsToText = (seconds) => {
  const days = Math.floor(seconds / 86400)
  const remainsFromDays = seconds % 86400
  const hours = Math.floor(remainsFromDays / 3600)
  const minutes = Math.floor(remainsFromDays % 3600 / 60)
  const remainingSeconds = Math.floor(remainsFromDays % 60)

  const value = `${days ? `${days}d ` : ''}${hours ? `${hours}h ` : ''}${minutes ? `${minutes}m ` : ''}${remainingSeconds ? `${remainingSeconds}s` : ''}`;

  return value
}
